"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default2 = exports.default = {
  props: {
    pageNum: {
      default: function _default() {
        return 1;
      }
    },
    pageSize: {
      default: function _default() {
        return 10;
      }
    },
    total: {
      default: function _default() {
        return null;
      }
    }
  },
  methods: {
    handleSizeChange: function handleSizeChange(val) {
      this.$emit("handleSizeChange", val);
    },
    handleCurrentChange: function handleCurrentChange(val) {
      this.$emit("handleCurrentChange", val);
    },
    changePageNum: function changePageNum() {
      this.$emit("update:pageNum", 1);
    }
  }
};